import React from 'react';
import { PropertyGroup } from './PropertyGroup';
import { DefaultSelectionInput } from '../PropertyInputs';

/**
 * Default selection property component for select/radio/checkbox
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const DefaultSelectionProperty = _ref => {
  let {
    field,
    updateField,
    selectedField
  } = _ref;
  if (!['select', 'radio', 'checkbox'].includes(field.type)) {
    return null;
  }

  // Checkbox and multi-select select fields use arrays for default values
  const isMultiSelect = field.type === 'checkbox' || field.type === 'select' && field.multiselect;
  if (isMultiSelect) {
    // Handle multi-select (checkbox or multi-select select)
    const defaultValue = Array.isArray(field.defaultValue) ? field.defaultValue : [];
    const fieldOptions = field.options || [];
    const handleToggle = optionValue => {
      const currentValues = Array.isArray(field.defaultValue) ? [...field.defaultValue] : [];
      const index = currentValues.indexOf(optionValue);
      if (index > -1) {
        // Remove if already selected
        currentValues.splice(index, 1);
      } else {
        // Add if not selected
        currentValues.push(optionValue);
      }
      updateField(selectedField, {
        defaultValue: currentValues
      });
    };
    return /*#__PURE__*/_jsx(PropertyGroup, {
      label: "Default Selection",
      children: fieldOptions.length > 0 ? /*#__PURE__*/_jsx("div", {
        className: "property-checkbox-list",
        children: fieldOptions.map((option, index) => {
          const isChecked = defaultValue.includes(option.value);
          return /*#__PURE__*/_jsxs("label", {
            className: "property-checkbox-item",
            children: [/*#__PURE__*/_jsx("input", {
              type: "checkbox",
              checked: isChecked,
              onChange: () => handleToggle(option.value),
              className: "property-checkbox-input"
            }), /*#__PURE__*/_jsxs("span", {
              className: "property-checkbox-label",
              children: [option.label, " (", option.value, ")"]
            })]
          }, index);
        })
      }) : /*#__PURE__*/_jsx("p", {
        className: "help-text",
        children: "Add options first to set default selections"
      })
    });
  }

  // Single select (select or radio) - use dropdown
  return /*#__PURE__*/_jsx(PropertyGroup, {
    label: "Default Selection",
    children: /*#__PURE__*/_jsx(DefaultSelectionInput, {
      field: field,
      value: field.defaultValue || '',
      onChange: value => updateField(selectedField, {
        defaultValue: value
      })
    })
  });
};